/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'

import GroupLogo from 'components/features/GroupLogo';

import './GroupMenuSwitcher.css';

const GroupMenuSwitcher = ({ onClick }) => {
  return (
    <div className="cmp-groupmenuswitcher">
      <GroupLogo onClick={onClick} size="48px" hasDots={true} />
    </div>
  );
}

export default GroupMenuSwitcher;
